import { ClientQuery, ClientQueryOverview } from '../../types/client-query';

export function getQueryContext(clientQuery: ClientQueryOverview | ClientQuery): { url: string; label: string } | undefined {
    const url = location.pathname;
    if (clientQuery.worksheet) {
        if (clientQuery.worksheet.hasAccount) {
            return {
                label: clientQuery.worksheet.name,
                url: url.replace(/client-queries|dashboard/, `trial-balance/${clientQuery.worksheet.id}`),
            };
        }
        return {
            label: clientQuery.worksheet.name,
            url: url.replace(/client-queries|dashboard/, `other-schedules/${clientQuery.worksheet.id}`),
        };
    }

    return undefined;
}
